export default __webpack_public_path__ + "static/media/addBag1.6525e069.jpg";